module.exports = __webpack_public_path__ + "static/media/vase3.838c7956.jpg";